import Vue from 'vue'

import Clipboard from 'v-clipboard'
import browserDetect from 'vue-browser-detect-plugin'
import VueTippy from 'vue-tippy'
import 'tippy.js/themes/light.css'
import DMFPlugin from './plugins/DMFPlugin'; // Adjust path as needed

import App from './App.vue'
import store from './store'

Vue.use(Clipboard)
Vue.use(browserDetect)
Vue.use(DMFPlugin)
// Vue.use(VueTippy, {
//   interactive: false,
//   arrow: true,
//   arrowTransform: 'scale(1.5)',
//   trigger: 'click',
//   placement: 'bottom',
//   theme: 'light',
// })

Vue.use(
  VueTippy,
  // optional
  {

    component: 'tippy', // => <tippy/>
    componentSingleton: 'tippy-singleton', // => <tippy-singleton/>
  }
)

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
